import { render, staticRenderFns } from "./createJoin.vue?vue&type=template&id=3e3757b7&scoped=true&"
import script from "./createJoin.vue?vue&type=script&lang=js&"
export * from "./createJoin.vue?vue&type=script&lang=js&"
import style0 from "./createJoin.vue?vue&type=style&index=0&id=3e3757b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3757b7",
  null
  
)

export default component.exports